module.exports = __webpack_public_path__ + "media/images/btn_print_pdf-90ab0dd3623b47647dfbcc349323446c.gif";